require('angular/angular.js');
require('angular-animate/angular-animate.js');
require('angular-aria/angular-aria.js');
require('angular-auto-focus/angular-auto-focus.js');
require('angular-chart.js/angular-chart.js');
require('angular-feature-flags/dist/featureFlags.js');
require('angular-file-saver/dist/angular-file-saver.bundle.js');
require('angular-gist/angular-gist.js');
require('angular-i18n/angular-locale_en.js');
require('angular-material/modules/js/core/core.js');
require('angular-material/modules/js/showHide/showHide.js');
require('angular-material/modules/js/virtualRepeat/virtualRepeat.js');
require('angular-material/modules/js/backdrop/backdrop.js');
require('angular-material/modules/js/button/button.js');
require('angular-material/modules/js/dialog/dialog.js');
require('angular-material/modules/js/fabActions/fabActions.js');
require('angular-material/modules/js/fabSpeedDial/fabSpeedDial.js');
require('angular-material/modules/js/fabTrigger/fabTrigger.js');
require('angular-material/modules/js/tooltip/tooltip.js');
require('angular-material/modules/js/menu/menu.js');
require('angular-material/modules/js/icon/icon.js');
require('angular-material/modules/js/whiteframe/whiteframe.js');
require('angular-material/modules/js/panel/panel.js');
require('angular-material/modules/js/menuBar/menuBar.js');
require('angular-material/modules/js/select/select.js');
require('angular-material/modules/js/radioButton/radioButton.js');
require('angular-material/modules/js/card/card.js');
require('angular-messages/angular-messages.js');
require('angular-moment/angular-moment.js');
require('angular-promise-extras/angular-promise-extras.js');
require('angular-route/angular-route.js');
require('angular-sanitize/angular-sanitize.js');
require('angular-scroll/angular-scroll.js');
require('angular-strap/dist/angular-strap.js');
require('angular-strap/dist/angular-strap.tpl.js');
require('angular-summernote/dist/angular-summernote.js');
require('angular-touch/angular-touch.js');
require('angular-translate/dist/angular-translate.js');
require('angular-ui-router/release/angular-ui-router.js');
require('angular-web-notification/angular-web-notification.js');
require('arrive/src/arrive.js');
require('autosize/dist/autosize.js');
require('blueimp-canvas-to-blob/js/canvas-to-blob.js');
require('bootstrap-switch/dist/js/bootstrap-switch.js');
require('clipboard/lib/clipboard.js');
require('iframe-resizer/js/iframeResizer.js');
require('jquery/dist/jquery.js');
require('localforage/dist/localforage.js');
require('lodash/dist/lodash.js');
require('matchmedia-ng/matchmedia-ng.js');
require('moment/moment.js');
require('moment/locale/fr.js');
require('moment/locale/ru.js');
require('moment/locale/vi.js');
require('moment/locale/zh-cn.js');
require('ng-tags-input/build/ng-tags-input.js');
require('restangular/src/restangular.js');
require('summernote/dist/summernote.js');
require('ui-router-extras/release/ct-ui-router-extras.js');
require('ui-router-extras/release/modular/ct-ui-router-extras.dsr.js');
require('videogular/videogular.js');
require('videogular-buffering/vg-buffering.js');
require('videogular-controls/vg-controls.js');
require('videogular-overlay-play/vg-overlay-play.js');
require('angular-cookies/angular-cookies.js');
require('moment-timezone/builds/moment-timezone-with-data.js');
require('dompurify/dist/purify.js');
require('matchmedia/index.js');
require('re-tree/re-tree.js');
require('angular-dynamic-locale/src/tmhDynamicLocale.js');
require('./components/jquery.focus/dist/jquery.focus.js');
require('./components/bootstrap/dist/js/bootstrap.js');
require('./components/angular-file-upload/dist/angular-file-upload-shim.js');
require('./components/angular-component/dist/angular-component.js');
require('./components/ngInfiniteScroll/build/ng-infinite-scroll.js');
require('./components/jcrop/js/jquery.Jcrop.js');
require('./components/angular-file-upload/dist/angular-file-upload.js');
require('./components/openpaas-logo/openpaas-logo.js');
require('./components/angular-truncate/src/truncate.js');
require('./components/ngGeolocation/ngGeolocation.js');
require('./components/angular-uuid4/angular-uuid4.js');
require('./components/angular-bootstrap-switch/dist/angular-bootstrap-switch.js');
require('./components/ical.js/build/ical.js');
require('./components/char-api/lib/charAPI.js');
require('./components/angular-jstz/angular-jstz.js');
require('./components/angular-recursion/angular-recursion.js');
require('./components/angular-localforage/dist/angular-localForage.js');
require('./components/Chart.js/Chart.js');
require('./components/ng-device-detector/ng-device-detector.js');
require('./components/remarkable-bootstrap-notify/bootstrap-notify.js');
require('./components/angular-fullscreen/src/angular-fullscreen.js');
require('./components/dynamic-directive/dist/dynamic-directive.js');
require('./components/angularjs-naturalsort/dist/naturalSortVersion.min.js');
require('./components/offline/offline.js');
require('./components/lng-clockpicker/dist/bootstrap-clockpicker.js');
require('./components/angular-clockpicker/dist/angular-clockpicker.min.js');
require('./components/html5-desktop-notifications2/dist/Notification.js');
require('./components/awesome-angular-swipe/lib/awesome-angular-swipe.js');
require('./components/angular-scroll-glue/src/scrollglue.js');
require('./components/waves/dist/waves.js');
require('./components/angular-hotkeys/build/hotkeys.js');
require('./components/angular-sticky/dist/angular-sticky.js');
require('./components/ngclipboard/dist/ngclipboard.js');
require('./components/angular-colorpicker-directive/js/color-picker.js');
require('./js/material.js');
require('./components/material-admin/js/modules/form.js');
